var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiLink from "@material-ui/core/Link";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
export var LinkComponentName = "CosmosLink";
export var useLinkStyles = makeStyles(function (theme) { return ({
    root: {},
    startIcon: {
        marginRight: theme.spacing(0.5),
    },
    endIcon: {
        marginLeft: theme.spacing(0.5),
    },
    icon: {
        verticalAlign: "text-top",
    },
    primary: {
        "&:hover": {
            color: theme.palette.primary[800] || theme.palette.primary.dark,
        },
    },
    secondary: {
        "&:hover": {
            color: theme.palette.secondary[800] || theme.palette.secondary.dark,
        },
    },
    error: {
        "&:hover": {
            color: theme.palette.error.dark,
        },
    },
    textPrimary: {
        "&:hover": {
            color: theme.palette.common.black,
        },
    },
    textSecondary: {
        "&:hover": {
            color: theme.palette.text.primary,
        },
    },
}); }, { name: LinkComponentName });
export var Link = React.forwardRef(function (props, ref) {
    var classes = useLinkStyles(props);
    var className = props.className, children = props.children, color = props.color, _a = props.component, component = _a === void 0 ? "a" : _a, startIcon = props.startIcon, endIcon = props.endIcon, rootProps = __rest(props, ["className", "children", "color", "component", "startIcon", "endIcon"]);
    return (React.createElement(MuiLink, __assign({ color: color, underline: "none", component: component, className: clsx([classes.root, className]), ref: ref, TypographyClasses: {
            colorPrimary: classes.primary,
            colorSecondary: classes.secondary,
            colorError: classes.error,
            colorTextPrimary: classes.textPrimary,
            colorTextSecondary: classes.textSecondary,
        } }, rootProps),
        !!startIcon && React.createElement("span", { className: clsx(classes.icon, classes.startIcon) }, startIcon),
        children,
        !!endIcon && React.createElement("span", { className: clsx(classes.icon, classes.endIcon) }, endIcon)));
});
